import { useEffect, useState } from "react";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const NAMES = { c1: "Metaland Wolfpack Exclusive", c2: "Metaland Wolfpack", c3: "Project PUPS" };

export default function AdminNftPictures() {
  const [s, setS] = useState(null);
  const load = () => api.get("/admin/nft-pictures").then(({ data }) => setS(data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 8000); return () => clearInterval(t); }, []);
  const fill = async () => {
    try { await api.post("/admin/nft-pictures/fill"); toast.success("Fetching missing pictures in the background"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!s) return null;
  return (
    <div className="glass rounded-2xl p-6 max-w-3xl space-y-5" data-testid="admin-nft-pictures">
      <div>
        <h3 className="font-display text-xl text-amber-100">NFT pictures</h3>
        <p className="text-sm text-slate-400">Every Polygon NFT's picture, name and traits, copied once from OpenSea and saved here.</p>
      </div>
      {Object.entries(s.collections).map(([k, c]) => (
        <div key={k} data-testid={`nft-pictures-${k}`}>
          <div className="flex justify-between text-sm mb-1.5"><span className="text-slate-200">{NAMES[k]}</span>
            <span data-testid={`nft-pictures-count-${k}`} className="font-mono-game text-amber-200">{c.saved.toLocaleString()} / {c.total.toLocaleString()}</span></div>
          <div className="h-2 rounded-full bg-slate-800 overflow-hidden"><div className="h-full bg-gradient-to-r from-amber-500 to-amber-300 transition-[width] duration-700" style={{ width: `${(100 * c.saved) / c.total}%` }} /></div>
        </div>
      ))}
      <div className="flex flex-wrap items-center gap-4 pt-1">
        <button data-testid="nft-pictures-fill-btn" disabled={s.running} onClick={fill} className="ember-btn px-5 py-2.5 rounded-full text-sm inline-flex items-center gap-2 disabled:opacity-60">
          <RefreshCw className={`w-4 h-4 ${s.running ? "animate-spin" : ""}`} />{s.running ? "Fetching…" : "Fetch missing pictures"}
        </button>
        <p data-testid="nft-pictures-status" className="text-xs text-slate-400">
          {s.running ? "Running now. The site stays fully usable." : s.finished_at ? `Last run finished ${new Date(s.finished_at).toLocaleString()}` : "Not run yet."}
          {!s.running && s.error && <span className="block text-amber-300/90 mt-1">Paused: {s.error.includes("OpenSea key") ? `Waiting for OpenSea's free key. It retries on its own${s.retry_at ? ` from ${new Date(s.retry_at).toLocaleString()}` : ""}.` : s.error}</span>}
        </p>
      </div>
    </div>
  );
}
